import Vue from 'vue';
import WOW from 'wowjs';

if (process.client) {
  const wow = new WOW.WOW();
  wow.init();
  Vue.use(wow);
}
